// extracted by mini-css-extract-plugin
module.exports = {"title":"_1G5tn6pT4OtoL9yLF1028d","changeScheduleButton":"_2CiP6QwPfUxGsgJ3yCdHuh"};